/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { driver } from 'driver.js';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';

//import { fetchApi } from '../../../utils/methods';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { fetchApi } from '../../../utils/methods';
import { GetUserProductTourDetails } from '../../../redux/constants/apiConstants';

class Walkthrough extends Component {
  constructor(props) {
    super(props);
    this.driver = driver({
      showProgress: true,
      animate: true,
      keyboardControl: true,
      overlayClickNext: true,
      nextBtnText: 'Next',
      prevBtnText: 'Previous',
      doneBtnText: 'Finish',
      popoverClass: 'figma-tour-popover',
      onHighlightStarted: (stepNumber) => {
        this.handleStepChange(stepNumber);
      },
      onHighlight: (stepNumber) => {
        this.handleStepChange(stepNumber);
      },
      afterChange: (stepNumber) => {
        this.handleStepChange(stepNumber);
      },
      onCloseClick: (element, step, options) => {
        // console.log("Tour manually closed");
        this.props.productTourDetails?.product_tour_data?.admin_hdm ? this.handleFinishTour() : this.props.hideProductTour();
      },
      onDestroyStarted: (element, step, options) => {
        // console.log("Tour destroy started", step);
        // Optionally handle logic before destruction
      },
      onDestroyed: (element, step, options) => {
        // console.log("Tour fully destroyed", step);
        document.body.classList.remove('driver-on-first-step');
        document.body.classList.remove('driver-on-last-step');
        // this.props.hideProductTour();
      }
    });
    this.totalSteps = 11;
  }

  componentDidMount() {
    this.startTour();
  }


  componentDidUpdate(prevProps){
    if(prevProps.showWalkthrough != this.props.showWalkthrough){
      if(this.props.showWalkthrough){
        //document.body.classList.add('driver-on-first-step');
        this.startTour();
      }

    }

  }
  
  

  startTour = () => {
    const { manageHealthTabs } = this.props;
    const driverInstance = this.driver;

    this.driver.setSteps([
      {
        element: '#hdm-snapshot',
        popover: {
          title: 'Snapshot',
          description: 'Get a quick view of all active health initiatives. Track ongoing participation and engagement at a glance.',
          side: 'right',
          align: 'start',
          showButtons: ['next', 'close'],
          
        },
      },
      {
        element: '#hdm-year-dropdown', 
        popover: {
          title: 'Year filter',
          description: 'Switch between years to view initiatives launched in specific time periods and track year-over-year progress.',
          position: 'right',
        },
      },
      {
        element: '#hdm-launch-initiative',
        popover: {
          title: 'Launch initiative',
          description: 'Kick off a new wellness initiative for your team in just a few clicks.',
          position: 'right',
        },
      },
      {
        element: '#hdm-completed',
        popover: {
          title: 'Completed',
          description: 'See a list of all completed health initiatives. Review how they performed and who participated.',
          position: 'right',
          onNextClick: () => {
            manageHealthTabs("completed");
            const interval = setInterval(() => {
              if (document.querySelector('#hdm-eyeicon')) {
                clearInterval(interval);
                this.driver.moveNext();
              }
            }, 100);
          },
        },
      },
      {
        element: '#hdm-eyeicon',
        popover: {
          title: 'View completed initiative',  
          description: 'Dive deeper into any finished initiative to analyze results, participation, and overall impact.',
          position: 'right',
        },
      },
      {
        element: '#hdm-library',
        popover: {
          title: 'Library',
          description: 'Access a repository of all saved health initiative templates. Quickly reuse or modify existing initiatives.',
          position: 'right',
          onNextClick: () => {
            manageHealthTabs("library");
      
            let attempts = 0;
            const maxAttempts = 30; 
      
            const createInitiativeCheck = setInterval(() => {
              const target = document.querySelector('#hdm-create-initiative');        
              if (target && driverInstance) {
                clearInterval(createInitiativeCheck);
                driverInstance.moveNext();
              } else 
              {
                attempts++; //  increment separately
                if (attempts >= maxAttempts) {
                  clearInterval(createInitiativeCheck);
                }
              }
            }, 100);
          },
        },
      },
      
      {
        element: '#hdm-create-initiative',
        popover: {
          title: 'Create health initiative',
          description: 'Build a new initiative from scratch or using a template. Customize it to fit your team’s wellness goals.',
          position: 'right',
        },
      },
      
      {   
        element: '#hdm-wba-report',
        popover: {
          title: 'WBA reports',
          description: 'Get detailed insights from Wellness & Behavior Assessments collected during your initiatives.',
          position: 'right',
          onNextClick: () => {
            manageHealthTabs("wbareport");
            const interval = setInterval(() => {
              if (document.querySelector('#hdm-wba-overviewtab')) {
                clearInterval(interval);
                this.driver.moveNext();
              }
            }, 100);

          }
        },
      },
      {   
        element: '#hdm-wba-overviewtab',
        popover: {
          title: 'Overview',
          description: 'A summarized snapshot of health trends, risk factors, and participation rates. Key insights are available',
          position: 'right',
        },
      },
      {   
        element: '#hdm-wba-assessmenttab',
        popover: {
          title: 'Assesment',
          description: 'The Assessment tab displays category scores in fractions. Click any card to view detailed WBA responses below.',
          position: 'right',
        },
      },
      {   
        element: '#hdm-biometric',
        popover: {
          title: 'Biometric',
          description: 'The Biometric tab shows health scores, total biometrics, cost projections, and top health risks and concerns.',
          position: 'right',
          onNextClick: () => {
            manageHealthTabs("biometric");
            const interval = setInterval(() => {
              if (document.querySelector('#hdm-biometric-hover-view-button')) {
                clearInterval(interval);
                this.driver.moveNext();
              }
            }, 100);
          }
        //   onNextClick: () => {
        //     manageHealthTabs("biometric");
        //     // this.setState({ onHover: item.id }, () => {
        //     //   const checkEl = setInterval(() => {
        //     //     const el = document.querySelector('#hdm-biometric-hover-view-button');
        //     //     if (el) {
        //     //       clearInterval(checkEl);
        //     //       this.driver.moveNext(); // Proceed to next step
        //     //     }
        //     //   }, 100);
        //     // });
        //   }
        },
      },
      {   
        element: '#hdm-biometric-hover-view-button', 
        popover: {
          title: 'Health risk or concern info',
          description: 'See affected people, cost per person, and total health cost for each risk or concern.',
          position: 'right',
          onNextClick: () => this.handleFinishTour()
        },
      },
      
    ]);

    this.driver.drive(); 
  };
  handleFinishTour = () => {
    const productTourPayload = {
      company_id: this.props.companyId, 
      product_tour_data: {
        admin_hdm: false,
      }
    };
    //setShowModal(false);
    this.props.hideProductTour();
    this.props.productTourDetails?.product_tour_data?.admin_hdm && this.sendProductTourData(productTourPayload)
  };
  

  sendProductTourData = async (payload) => {
    try {
      const res = await fetchApi(GetUserProductTourDetails,  "POST", payload);
      if(res.status === "success"){
        toast.success(res?.data?.message)
        if (this.driver) {
          this.driver.destroy();  
        }
        
      }
      else {
        toast.error(res?.message?.message)
      }
      // if (res.data.success) {
      //   toast.error(res?.data?.message);
      // } else {
      //   toast.success(res?.data);
      //   //fetchCompanyCoreValues(companyInfo.id)
      // }
    }
    
    
    catch (error) {
      // toast.error(error)
    }
  }

  handleStepChange = (stepNumber) => {
    if (stepNumber === 1) {
      document.body.classList.add('driver-on-first-step');
      document.body.classList.remove('driver-on-last-step');
    } else if (stepNumber === this.totalSteps) {
      document.body.classList.add('driver-on-last-step');
      document.body.classList.remove('driver-on-first-step');
    } else {
      document.body.classList.remove('driver-on-first-step');
      document.body.classList.remove('driver-on-last-step');
    }
  };

  componentWillUnmount() {
    if (this.driver) {
      this.driver.destroy();
    }
    document.body.classList.remove('driver-on-first-step');
    document.body.classList.remove('driver-on-last-step');
    this.props.hideProductTour();
  }

  render() {
    return null;
  }
}

Walkthrough.propTypes = {
  setActiveTab: PropTypes.func,
  setSubTab: PropTypes.func,
  history:PropTypes.object,
  companyId:PropTypes.number,
  manageHealthTabs: PropTypes.func,
  showWalkthrough:PropTypes.bool,
  productTourDetails:PropTypes.object,
  hideProductTour:PropTypes.func
//   item: PropTypes.object,
//   setOnHover: PropTypes.func, 
};

// export default withRouter((Walkthrough));
const mapStateToProps = (state) => ({
  companyBrandingDetails: state.wellnessDashboard.companyBrandingDetails,
  departmentDetails: state.companyDashboard.companyPeopleDepartment,
  locationDetails: state.companyDashboard.companyPeopleLocation,
  productTourDetails: state.profileData.productTourDetails,

});


export default withRouter(connect(mapStateToProps, null)(Walkthrough));


